import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default function initTimeline() {

	const timelines = document.querySelectorAll('.mod-timeline');

	timelines.forEach(el => {
		const slider = el.querySelector('.swiper');

		const swiper = new Swiper(slider, {
			modules: [Navigation],
	    slidesPerView: 3,
	    loop: false,
	    speed: 600,
	    slidesOffsetAfter: 200,
	    slidesOffsetBefore: 10,
	    slideToClickedSlide: true,
		  // Navigation arrows
		  navigation: {
		    nextEl: el.querySelector('.swiper-button-next'),
		    prevEl: el.querySelector('.swiper-button-prev'),
		  },
		  breakpoints: {
		    992: {
		      slidesOffsetBefore: 40,
	    		slidesOffsetAfter: 300,
		    },
		  }
	  });


	  const images = el.querySelectorAll('.timeline__images__item');

	  images[0].classList.add('active');

	  const contents = el.querySelectorAll('.timeline__content__item');

	  contents[0].classList.add('active');

	  swiper.on('activeIndexChange', function () {
		  images.forEach(img => {
		  	img.classList.remove('active');
		  });

		  images[swiper.activeIndex].classList.add('active');


	  	el.querySelector('.timeline__content__item.active').classList.remove('active');
	  	contents[swiper.activeIndex].classList.add('active');
		});

	});


}